<template><svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 326.54 305.91" style="enable-background:new 0 0 326.54 305.91;" xml:space="preserve">
<g>
	<g>
		<path d="M74.34,129.61c1.15,6.08,14.31,51.81,54.61,51.81s53.46-45.72,54.61-51.81c5.6-0.33,13.49-19.73,13.49-32.4
			s-8.22-10.69-8.22-10.69s4.27-11.03,4.27-23.35c0-23.02-5.23-38.32-19.41-41.03C169.12,13.86,152.29,0,128.94,0
			S92.43,13.36,86.51,18.58C80.84,23.59,64.8,40.13,64.8,63.16c0,12.34,4.27,23.35,4.27,23.35s-8.22-1.98-8.22,10.69
			S68.74,129.27,74.34,129.61z"/>
		<path d="M227.23,198.78v3.52h-23.64c-6.71,0-12.15,6.47-12.15,14.45v72.06c0,6.1,3.17,11.31,7.67,13.43
			c-15.25,2.03-33.03,3.67-68.45,3.67c-79.23,0-127.95-30.79-127.95-30.79S0,256.74,0,240.7c0-36.76,19.1-37.41,36.87-44.06
			c17.76-6.67,29.24-11.45,45.78-22.55l28.37,86.93l10.85-30.27c0,0-10.43-13.36-10.43-24.16c0-5.06,3.68-12.68,17.5-12.68
			c13.82,0,17.5,7.62,17.5,12.68c0,10.8-10.42,24.16-10.42,24.16l10.86,30.27l28.36-86.93c16.53,11.1,28.01,15.88,45.77,22.55
			C223.08,197.41,225.16,198.1,227.23,198.78z"/>
	</g>
	<path d="M314.28,211.55h-23.94v-8.42c0-8.06-6.56-14.61-14.61-14.61h-22.84c-8.06,0-14.61,6.55-14.61,14.61v8.42h-23.87
		c-6.77,0-12.26,5.49-12.26,12.26v61.16c0,6.77,5.49,12.26,12.26,12.26h99.87c6.77,0,12.26-5.49,12.26-12.26v-61.16
		C326.54,217.04,321.05,211.55,314.28,211.55z M250.28,201.83c0-1.44,1.17-2.61,2.61-2.61h22.84c1.44,0,2.61,1.17,2.61,2.61v9.73
		h-28.06V201.83z"/>
</g>
</svg>
</template>